import React, { useState, useEffect } from 'react';
import { CalendarClock, Check } from 'lucide-react';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { API } from '@/utils/api';
import axios from 'axios';
import { toast } from 'sonner';

const TIME_SLOTS = [];
for (let h = 7; h <= 19; h++) {
  for (let m = 0; m < 60; m += 30) {
    TIME_SLOTS.push(`${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`);
  }
}

export const VehiclePickupSection = ({ woId, workOrder, appointment, onUpdated }) => {
  const [pickupDate, setPickupDate] = useState('');
  const [pickupTime, setPickupTime] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const pd = workOrder?.pickup_date || appointment?.pickup_date || '';
    const pt = workOrder?.pickup_time || appointment?.pickup_time || '';
    setPickupDate(pd);
    setPickupTime(pt);
  }, [workOrder, appointment]);

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/work-orders/${woId}`, {
        pickup_date: pickupDate,
        pickup_time: pickupTime,
      });
      toast.success('Date de reprise enregistree');
      if (onUpdated) onUpdated();
    } catch {
      toast.error('Erreur lors de la sauvegarde');
    } finally {
      setSaving(false);
    }
  };

  const hasPickup = pickupDate || pickupTime;
  const formattedDate = pickupDate
    ? new Date(pickupDate).toLocaleDateString('fr-CH', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' })
    : '';

  return (
    <Card className="p-4 rounded-xl space-y-3 border-2 border-emerald-200 bg-emerald-50/30" data-testid="vehicle-pickup-section">
      <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
        <CalendarClock className="w-4 h-4 text-emerald-600" />
        Reprise du vehicule
        {hasPickup && (
          <span className="ml-auto text-xs font-medium text-emerald-700 bg-emerald-100 px-2 py-0.5 rounded-full">
            {formattedDate}{pickupTime ? ` a ${pickupTime}` : ''}
          </span>
        )}
      </h3>
      <div className="grid grid-cols-3 gap-3 items-end">
        <div className="space-y-1">
          <label className="text-xs font-medium text-slate-600">Date de reprise</label>
          <Input
            type="date"
            value={pickupDate}
            onChange={(e) => setPickupDate(e.target.value)}
            data-testid="wo-pickup-date"
          />
        </div>
        <div className="space-y-1">
          <label className="text-xs font-medium text-slate-600">Heure de reprise</label>
          <Select value={pickupTime} onValueChange={setPickupTime}>
            <SelectTrigger data-testid="wo-pickup-time">
              <SelectValue placeholder="--:--" />
            </SelectTrigger>
            <SelectContent>
              {TIME_SLOTS.map(t => (
                <SelectItem key={t} value={t}>{t}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
        <Button
          onClick={save}
          disabled={saving}
          size="sm"
          className="bg-emerald-600 hover:bg-emerald-700 text-white"
          data-testid="save-pickup-btn"
        >
          <Check className="w-4 h-4 mr-1" />
          {saving ? 'Enregistrement...' : 'Enregistrer'}
        </Button>
      </div>
    </Card>
  );
};
